import React from "react";

export function FacebookMessengerOutlined({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 2C12.3477 2 2 11.5977 2 23.5C2 30.0078 5.13281 35.7852 10 39.7188V48.6562L11.4688 47.875L18.6875 44.125C20.7031 44.6641 22.8008 45 25 45C37.6523 45 48 35.4023 48 23.5C48 11.5977 37.6523 2 25 2ZM25 4C36.6445 4 46 12.7578 46 23.5C46 34.2422 36.6445 43 25 43C22.8359 43 20.7422 42.6875 18.7812 42.125L18.4062 42.0312L18.0625 42.2188L12 45.375V38.8125L11.625 38.5312C6.96094 34.9414 4 29.5391 4 23.5C4 12.7578 13.3555 4 25 4ZM22.7188 17.7188L10.6875 30.4688L21.5 24.4062L27.2812 30.5938L39.1562 17.7188L28.625 23.625L22.7188 17.7188Z"
        fill="currentColor"
      />
    </svg>
  );
}
